import { Box } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import { PendenciasParametrosHeader } from './PendenciasParametrosHeader';
import { PendenciasParametrosFilters } from './PendenciasParametrosFilters';

export const PendenciasParametros = props => {
  const { filters, setFilters } = props;

  return (
    <Box mb={2}>
      <TableHeader>
        <PendenciasParametrosHeader filters={filters} setFilters={setFilters} />
        <PendenciasParametrosFilters filters={filters} setFilters={setFilters} />
      </TableHeader>
    </Box>
  );
};

PendenciasParametros.propTypes = {
  filters: PropTypes.shape({
    parceiro: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
